import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import TariffCodeContMain from "presentation/view/container/TariffCode/TariffCodeContMain";

CommonEntrypoint(<TariffCodeContMain/>)